// Real Mechelen Beach images sourced from mechelenbeach.be + client uploads
// Top thin navigation bar (info + media + social handled separately)
export const TOP_NAV = [
  { label: "Line-up", to: "/line-up" },
  { label: "Partners", to: "/partners" },
  { label: "Vrijwilligers", to: "/vrijwilligers" },
  { label: "Contact", to: "/contact" },
];

export const TOP_NAV_MEDIA = {
  label: "Media",
  items: [
    { label: "Foto's", to: "/media/fotos" },
    { label: "Video", to: "/media/video" },
  ],
};

// Main navigation bar — primary pages
export const MAIN_NAV = [
  {
    label: "Praktische info",
    items: [
      { label: "Openingsuren", to: "/praktische-info/openingsuren" },
      { label: "Bereikbaarheid", to: "/praktische-info/bereikbaarheid" },
      { label: "Menukaart", to: "/praktische-info/menukaart" },
    ],
  },
  { label: "Programma", to: "/programma" },
  { label: "Strandbar", to: "/strandbar" },
  { label: "Beachvolleybal", to: "/beachvolleybal" },
  { label: "Kinderstrand", to: "/kinderstrand" },
  { label: "Sportstrand", to: "/sportstrand" },
];

// Backwards-compat: keep NAV_ITEMS exported (used by Footer if needed)
export const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "Programma", to: "/programma" },
  { label: "Strandbar", to: "/strandbar" },
  { label: "Beachvolleybal", to: "/beachvolleybal" },
  { label: "Kinderstrand", to: "/kinderstrand" },
  { label: "Sportstrand", to: "/sportstrand" },
  { label: "Partners", to: "/partners" },
  { label: "Contact", to: "/contact" },
];

export const SOCIALS = {
  facebook: "https://www.facebook.com/mechelenbeach",
  instagram: "https://www.instagram.com/mechelen.beach/",
};

export const CONTACT_EMAIL = "mechelenbeach@gmail.com";

// Accurate Google Maps share URL supplied by the client
export const MAPS_SHARE_URL = "https://maps.app.goo.gl/rWrn41yvYKbqcBNX6";

// Zandpoortvest parking info link
export const PARKING_ZANDPOORTVEST_URL = "https://www.mechelen.be/parking-zandpoortvest";

// Parking De Nekker — aanbevolen parking voor Mechelen Beach
export const PARKING_DE_NEKKER_URL =
  "https://www.google.com/maps/search/?api=1&query=Parking+De+Nekker+Mechelen";

export const LOCATION = {
  name: "Mechelen Beach – Douaneplein / Transit M",
  street: "Douaneplein",
  city: "Mechelen",
  postal: "2800",
  country: "België",
  mapsUrl: "https://maps.app.goo.gl/rWrn41yvYKbqcBNX6",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Mechelen+Beach+Douaneplein+Mechelen&output=embed",
};

// Mechelen Beach vzw — official organisation details
export const ORG = {
  name: "Mechelen Beach vzw",
  street: "Nieuwe Kapucijnenstraat 10",
  postal: "2800",
  city: "Mechelen",
};

// Event constants — Phase 1 (2026)
export const EVENT = {
  edition: "5e editie",
  startDate: "16/07/2026",
  endDate: "09/08/2026",
  dateRange: "16/07/2026 – 09/08/2026",
};

export const BEACHVOLLEY = {
  edition: "Editie 2026",
  dateRange: "16/07/2026 – 19/07/2026",
  registerUrl: "https://app.webhero-bookings.com/mechelen-beach-vzw",
};

// Real sponsor logos — customer-assets CDN + local public assets (production-safe)
const CLIENT_LOGOS = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts";
const LOCAL_LOGOS = "/images/partners";

export const SPONSORS = [
  { name: "Stad Mechelen", url: "https://www.mechelen.be/", logo: `${LOCAL_LOGOS}/stad-mechelen.png` },
  { name: "Nationale Loterij", url: "https://www.nationale-loterij.be/", logo: `${LOCAL_LOGOS}/nationale-loterij.jpg` },
  { name: "Plantenhotel Nauwelaerts", url: "https://www.plantencentrumexotica.be/plantenhotel-overwintering/", logo: `${LOCAL_LOGOS}/plantenhotel-nauwelaerts.jpg`, prominent: true },
  { name: "RTV", url: "https://www.rtv.be/", logo: `${LOCAL_LOGOS}/rtv.jpg` },
  { name: "Sport Vlaanderen", url: "https://www.sport.vlaanderen/", logo: `${CLIENT_LOGOS}/5n4s3v6u_sport_vlaanderen.png` },
  { name: "Radio Reflex", url: "https://www.radioreflex.be/", logo: `${LOCAL_LOGOS}/radio-reflex.jpg` },
  { name: "Van Langendonck", url: "https://www.vanlangendonck.com/", logo: `${LOCAL_LOGOS}/van-langendonck.jpg` },
  { name: "Wim Verhuur", url: "https://www.wimverhuur.be/", logo: `${LOCAL_LOGOS}/wim-verhuur.jpg` },
  { name: "Frituur Put", url: "#", logo: `${LOCAL_LOGOS}/frituur-put.png` },
  { name: "PDSS", url: "https://pdss.eu/", logo: `${LOCAL_LOGOS}/pdss.png` },
  { name: "Vegobel", url: "https://www.vegobel.be/", logo: `${CLIENT_LOGOS}/g9xymn34_Vegobel.png`, prominent: true },
  { name: "Elevate", url: "https://elevate.be/", logo: `${LOCAL_LOGOS}/elevate.png` },
  { name: "Napoleon Score", url: "https://napoleonscore.be/nl-BE/favorites", logo: `${CLIENT_LOGOS}/2gfm7sl4_Napoleon_Score_Red_resized.png` },
  { name: "SMC Mechelen", url: "https://www.starmobilitycenter.be/mechelen-wemmel/", logo: `${CLIENT_LOGOS}/97x5ds2r_SMC%20Mechelen.png`, darkBg: true, enlarge: true },
  { name: "Eventa Rent", url: "https://www.eventarent.be/", logo: `${CLIENT_LOGOS}/vrfqstoz_Eventarent.png` },
  { name: "T'Seyen Foodservice", url: "https://www.tseyenfoodservice.be/", logo: `${CLIENT_LOGOS}/lluuxbco_t%27seyen.png`, darkBg: true },
  { name: "ERA Vijfhoek", url: "https://www.era.be/nl/era-vijfhoek", logo: `${CLIENT_LOGOS}/38cn3cgz_ERA.png`, medium: true },
  { name: "Paintball The Gathering", url: "https://www.thegathering.be/", logo: `${CLIENT_LOGOS}/fybzd3xq_The%20gathering.jpeg` },
  { name: "KU Leuven Campus De Nayer", url: "https://www.kuleuven.be/campussen/campus-de-nayer", logo: `https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/duhbkchu_Campus%20Leuven.png`, medium: true },
  { name: "Videotake", url: "https://www.videotake.be/", logo: `${CLIENT_LOGOS}/h7ht2en8_Videotake-Logo-2.PNG` },
  { name: "Takeldienst Hendrickx", url: "https://www.takeldienst-hendrickx.be/home/", logo: `https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/nm29op1k_Takeldienst.png` },
  { name: "Mi-sure", url: "https://mi-sure.be/nl-be/over-ons", logo: `https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/7qcygjvm_Mi%20sure.png` },
];

// Hoofdpartner — premium prominent placement on homepage + partners page
export const HOOFDPARTNER = {
  name: "Vwala",
  role: "Hoofdpartner",
  url: "https://www.vwala.be/",
  logo: `https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/pz63lx8r_Vwala_Primary_Logo_PMS_Purple800%20%281%29.png`,
};

// Beachvolley partners — names + assets (only render publicly when logo present)
export const BEACHVOLLEY_PARTNERS = [
  {
    name: "Napoleon Score",
    role: "Hoofdpartner Beachvolley",
    logo: `${CLIENT_LOGOS}/2gfm7sl4_Napoleon_Score_Red_resized.png`,
    url: "https://napoleonscore.be/en-BE",
    main: true,
  },
  {
    name: "KBC",
    logo: `${CLIENT_LOGOS}/7zjf9myg_kbc.png.png`,
    url: "https://www.kbc.be/particulieren/nl.html",
  },
  {
    name: "Sarens",
    logo: `${CLIENT_LOGOS}/0q9m6tgw_sarens.png.png`,
    url: "https://www.sarens.com/",
  },
  {
    name: "Belven",
    logo: `${CLIENT_LOGOS}/gov36av8_belven.png.png`,
    url: "https://www.belven.be/en",
  },
  {
    name: "Cargill",
    logo: `${CLIENT_LOGOS}/3ped77os_cargill.png.png`,
    url: "https://www.cargill.be/en/home",
    small: true,
  },
];

// Activiteitenpartners — partners die helpen het programma vorm te geven.
// Render only when official logos are uploaded (do not invent or scrape).
export const ACTIVITEITEN_PARTNERS = [
  { name: "Kinderstad Mechelen", url: "https://www.mechelen.be/vrije-tijd-sport-en-cultuur/jongeren-en-kinderen/kinderen", logo: `${CLIENT_LOGOS}/rs6hxrzz_kinderstad_mechelen.png` },
  { name: "Speelgoedmuseum Mechelen", url: "https://www.speelgoedmuseum.be/", logo: `${CLIENT_LOGOS}/ljenm9jr_speelgoedmuseum_mechelen.png` },
  { name: "Badminton Vlaanderen", url: "https://www.badmintonvlaanderen.be/", logo: `${CLIENT_LOGOS}/lnjn62y7_badminton_vlaanderen.png` },
  { name: "Roundnet Mechelen", url: "https://roundnetmechelen.be/", logo: `${CLIENT_LOGOS}/fss07hfm_Roundnet%20Mechelen.png`, darkBg: true, enlarge: true },
  { name: "Capoeira Meia Lua", url: "https://capoeirista.be/", logo: `${CLIENT_LOGOS}/po7nbckc_capoeira_meia_lua.png` },
  { name: "Circolito", url: "https://www.circolito.be/", logo: `${CLIENT_LOGOS}/21qcm8dc_circolito.png` },
  { name: "Salsa Titanico", url: "https://www.instagram.com/salsatitanico/", logo: `${CLIENT_LOGOS}/hupws0xz_salsa_titanico.png` },
  { name: "Skatehouse", url: "https://www.skatehouse.be/", logo: `${CLIENT_LOGOS}/9jkl2yie_skatehouse.png` },
  { name: "Sport Vlaanderen", url: "https://www.sport.vlaanderen/", logo: `${CLIENT_LOGOS}/5n4s3v6u_sport_vlaanderen.png` },
  { name: "JETI", url: "https://jetikampen.be/", logo: `${CLIENT_LOGOS}/hp7ssdrx_jeti.png` },
  { name: "Freespect", url: "https://www.freespect.be/", logo: `${CLIENT_LOGOS}/gxpaif64_freespect.png` },
  { name: "KMSK Schaakkring", url: "https://www.kmsk.eu/", logo: `${CLIENT_LOGOS}/5v6t546y_kmsk_schaakkring.png` },
  { name: "Busta Move", url: "https://bustamove.be/", logo: `${CLIENT_LOGOS}/c3e5suv0_busta_move.png` },
  { name: "Maanrock", url: "https://maanrock.be/", logo: `${CLIENT_LOGOS}/45gbkvvj_maanrock.png` },
  { name: "RAM Atletiek", url: "https://ram-atletiek.be/", logo: `${CLIENT_LOGOS}/uqcwy641_ram_atletiek.png` },
  { name: "Run High Collective", url: "https://www.instagram.com/runhighcollective/", logo: `${CLIENT_LOGOS}/6n3u69kz_run_high_collective.png` },
  { name: "Bon Marché", url: "https://www.instagram.com/its.bon.marche/", logo: `${CLIENT_LOGOS}/0fvgrq5r_bon_marche.png` },
  { name: "Vibrationz", url: "https://www.vibrationz.be/", logo: `${CLIENT_LOGOS}/gon7ignj_Vibrationz.jpg` },
  { name: "L'Eau De Vie", url: "https://www.instagram.com/leaudevie_official/", logo: `${CLIENT_LOGOS}/vex12i0f_L%27eau%20De%20Vie.jpg` },
  { name: "Single Events 2800", url: "https://www.instagram.com/singleevents2800/", logo: `${CLIENT_LOGOS}/53m7ixhz_Single%20Events%202800.jpg` },
  { name: "I.shape", url: "https://www.instagram.com/i.shape.be/", logo: `${CLIENT_LOGOS}/dc4l2trh_I.shape.jpg`, shrink: true },
  { name: "SmacK That", url: "https://www.instagram.com/smack_that.be/", logo: `${CLIENT_LOGOS}/sdat4r3n_Smack%20that%20Logo.jpeg` },
];

// Algemene voorwaarden beachvolley 2026 — PDF
export const BEACHVOLLEY_TERMS_PDF =
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/u8a4wkrv_ALGEMENE-VOORWAARDEN-MECHELEN-BEACH-VOLLEYBALTORNOOI-2026.pdf";

// Infodossier beachvolley 2026 — PDF
export const BEACHVOLLEY_INFODOSSIER_PDF =
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/9zznm4i9_INFODOSSIER%20MECHELEN%20BEACH%20VOLLEYBAL%202026_.pdf";

// Official Mechelen Beach logo — dark version (for light backgrounds, header/footer)
export const LOGO =
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/ettepjsc_logo-mechelen-beach-sharp.png.png";

// Official Mechelen Beach logo — white transparent (latest uploaded version)
export const LOGO_WHITE =
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/yjjj7x8y_mechelen-beach-logo-white-transparent.png.png";

// Homepage hero background video — final uploaded version
export const HERO_VIDEO =
  "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/9mgcywzl_mechelen-beach-homepage-video-final.mp4.mp4";

// Client-uploaded sfeer/atmosphere photos
const CLIENT = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts";
const SFEER_VOLLEY = `${CLIENT}/v267lekg_WhatsApp-Image-2022-07-29-at-2.08.55-PM-300x350.jpg`;
const SFEER_TERRACE = `${CLIENT}/5kodsdbd_foto-strandbar-galerij-extra-scaled-300x300.jpg`;
const STRANDBAR_NEW = `${CLIENT}/060my1ak_strandbar.jpg.jpg`;
const HERO_NEW = `${CLIENT}/u8q9ntwy_Hero%20Image.png`;
const WAT_IS_NEW = `${CLIENT}/l4wmr63e_Wat%20is%20mechelen%20beach.jpg`;
const VOLLEY_TEAM = `${CLIENT}/hp5u2iol_WhatsApp-Image-2022-07-31-at-5.21.31-PM-1-684x1024.jpg`;
const STRANDBAR_NEW_01 = `${CLIENT}/842edjok_strandbar-new-01.jpg.jpg`;
const STRANDBAR_NEW_02 = `${CLIENT}/rd7h7zhn_strandbar-new-02.jpg.jpg`;
const STRANDBAR_NEW_03 = `${CLIENT}/5k3a1z0m_strandbar-new-03.jpg.jpg`;
const STRANDBAR_NEW_04 = `${CLIENT}/i30ary0k_strandbar-new-04.jpg.jpg`;
const STRANDBAR_NEW_05 = `${CLIENT}/iytyoez8_strandbar-new-05.jpg.jpg`;
// 3 latest uploads — new strandbar atmosphere photos (no duplicates with hero / Wat te beleven)
const STRANDBAR_GAL_06 = `${CLIENT}/ljnzujev_502624258_18009995573749830_1813264353136151105_n.jpg`;
const STRANDBAR_GAL_07 = `${CLIENT}/3swvw126_522862218_18016534928749830_6680808665430924383_n.jpg`;
const STRANDBAR_GAL_08 = `${CLIENT}/7nc07ti6_MechelenBeach_VolleyKids-73.jpg`;
// Kinderstrand — 5 new official client uploads (2026)
const KIDS_NEW_SPRINGKASTEEL = `${CLIENT}/777d0zj0_sprinkastelen.jpg`;
const KIDS_NEW_SCHMINK = `${CLIENT}/busmfpzt_knutselen.jpg`;
const KIDS_NEW_KNUTSELEN = `${CLIENT}/1j27uzg7_519690111_732431816209234_6039937668951266796_n.jpg`;
const KIDS_NEW_ROMMIE = `${CLIENT}/r4t9gvy1_kinderstrand%20-%20rommie.jpg`;
const KIDS_NEW_MASCOT = `${CLIENT}/obdal8p2_kinderstrand.jpg`;
// 4 newest Kinderstrand activity uploads (skate, cirkus, boogschieten, kabouterwandeling)
const KIDS_ACT_SKATE = `${CLIENT}/mxc09loe_kinderstrand%20-%20skate.jpg`;
const KIDS_ACT_CIRKUS = `${CLIENT}/iqv36a9o_cirkolito%20cirkusinitiatie.jpg`;
const KIDS_ACT_BOOG = `${CLIENT}/ahv63l1e_kinderstrand%20-%20boogschieten.jpg`;
const KIDS_ACT_KABOUTER = `${CLIENT}/0lfi7jqf_kabouterwandeling.jpg`;
// Line-up 2026 — official avondprogramma poster
const LINEUP_POSTER = `${CLIENT}/wl3rvyv8_Line%20Up%20Mechelen%20Beach%202026.png`;
// Latest uploads — Line-up nightlife atmosphere + Bereikbaarheid aerial overview
const LINEUP_PARTY = `${CLIENT}/slq5iltp_521673997_732597639525985_1441239269241234948_n.jpg`;
const SITE_AERIAL = `${CLIENT}/ek61gv79_Schermafbeelding%202025-02-11%20175501.png`;
const BEACHVOLLEY_OFFICIAL = `${CLIENT}/a6l674ow_beachvolley-official-image-2026.jpg.png`;
const BEACHVOLLEY_TEAM_HUDDLE = `${CLIENT}/3w0g510v_beachvolley-sfeer-team-huddle-2026.jpg.jpg`;

// Additional sfeer/content uploads for replacing broken WP CDN images
const MB40 = `${CLIENT}/kyk02ynp_Mechelen%20Beach-40%20%281%29.jpg`;
const MB42 = `${CLIENT}/ojjsnbpg_Mechelen%20Beach-42%20%281%29%20%281%29.jpg`;
const WHATSAPP_521 = `${CLIENT}/efnespw4_WhatsApp%20Image%202022-07-31%20at%205.21.35%20PM%20%281%29.jpeg`;
const CAPOEIRA_25 = `${CLIENT}/ap16ggfh_capoeira-25%20%281%29.jpg`;

// Images used across the site
export const IMAGES = {
  // Hero / atmosphere
  heroMain: HERO_NEW,
  heroPoster: HERO_NEW, // poster fallback for video hero
  watIs: WAT_IS_NEW,
  volleyTeam: VOLLEY_TEAM,
  heroWide: HERO_NEW,
  sunsetCrowd: LINEUP_PARTY,
  beachDeco: STRANDBAR_NEW_03,
  party1: LINEUP_PARTY,

  // Client uploads
  sfeerTerrace: SFEER_TERRACE,
  sfeerVolley: SFEER_VOLLEY,
  strandbarNew: STRANDBAR_NEW,

  // Strandbar — new official client uploads (2026)
  strandbarNew01: STRANDBAR_NEW_01,
  strandbarNew02: STRANDBAR_NEW_02,
  strandbarNew03: STRANDBAR_NEW_03,
  strandbarNew04: STRANDBAR_NEW_04,
  strandbarNew05: STRANDBAR_NEW_05,
  strandbarGal06: STRANDBAR_GAL_06,
  strandbarGal07: STRANDBAR_GAL_07,
  strandbarGal08: STRANDBAR_GAL_08,

  // Strandbar
  strandbarMain: STRANDBAR_NEW,
  strandbarDrinks: STRANDBAR_NEW_01,
  strandbarVibe: STRANDBAR_NEW_02,
  strandbarFood: STRANDBAR_NEW_03,
  strandbarNight: STRANDBAR_NEW_04,
  strandbarBar: STRANDBAR_NEW_05,
  strandbarFoodB: STRANDBAR_GAL_06,
  strandbarTable: STRANDBAR_GAL_07,

  // Kinderstrand / Speelstrand — new official 2026 uploads
  kidsNewSpringkasteel: KIDS_NEW_SPRINGKASTEEL,
  kidsNewSchmink: KIDS_NEW_SCHMINK,
  kidsNewKnutselen: KIDS_NEW_KNUTSELEN,
  kidsNewRommie: KIDS_NEW_ROMMIE,
  kidsNewMascot: KIDS_NEW_MASCOT,
  kidsActSkate: KIDS_ACT_SKATE,
  kidsActCirkus: KIDS_ACT_CIRKUS,
  kidsActBoog: KIDS_ACT_BOOG,
  kidsActKabouter: KIDS_ACT_KABOUTER,
  lineupPoster: LINEUP_POSTER,
  lineupParty: LINEUP_PARTY,
  siteAerial: SITE_AERIAL,

  // Kinderstrand / Speelstrand
  kinderstrandMain: KIDS_NEW_MASCOT,
  kinderstrandSpring: KIDS_NEW_SPRINGKASTEEL,
  kinderstrandPlay: KIDS_NEW_KNUTSELEN,
  kinderstrandFamily: KIDS_NEW_ROMMIE,

  // Sportstrand — bijgewerkte officiële foto's (airbadminton + roundnet 2024)
  sportstrandMain: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/v10fg3lx_airbadminton%202024.jpg",
  sportstrandWide: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/wp8xxvon_airbadminton%202024%20-%202.jpg",
  sportstrandGal1: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/a8avyx6c_airbadminton%202024%20-%203.jpg",
  sportstrandGal2: BEACHVOLLEY_TEAM_HUDDLE,
  sportstrandGal3: "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/zjo4nq3a_roundnet%20%281%29.jpg",
  sportstrandTeam: VOLLEY_TEAM,

  // Beachvolleybal
  beachvolleyOfficial: BEACHVOLLEY_OFFICIAL,
  beachvolleyTeamHuddle: BEACHVOLLEY_TEAM_HUDDLE,
  volleybalHero: BEACHVOLLEY_OFFICIAL,
  volleybal1: BEACHVOLLEY_TEAM_HUDDLE,
  volleybal2: MB40,
  volleybal3: MB42,

  // Misc
  whatsappCrowd: WHATSAPP_521,
};
